<template>
  <div>
    <div class="groupsManage clearfix" v-if="groupsLength != 0">
      <div class="createGroup clearfix">
        <span>共
          <em>{{groupsLength}}</em> 个小组</span>
        <button @click="addGroup">新建小组</button>
      </div>
      <div class="groupsList" v-for="(item,index) in groups" :key="index" v-if="item.title != '未分组'">
        <p>
          <span>{{item.title}}</span>
          <ul class="fr">
            <li>
              <img src="../../assets/img/classEdit-icon.png" alt="">
              <span class="edit fr" @click="edit(index)">编辑</span>
            </li>
            <li>
              <img src="../../assets/img/delete-icon.png" alt="">
              <span class="delete fr" @click="delTeam(index)">删除</span>
            </li>
          </ul>
        </p>
        <div class="stuList">
          <ul>
            <li v-for="(sitem,sindex) in item.data" :key="sindex">{{sitem.userName}}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="noClassList" v-else>
      <img src="../../assets/img/null.png" alt="">
      <p>该班级下还没有小组，赶紧添加一个吧</p>
      <button @click="addGroup">新建小组</button>
    </div>
    <notice :params="params" :isNotice="isNotice" @isConfirm="isConfirm"></notice>
  </div>
</template>
<script>
import fetch from "./../../fetch";
import notice from "./../notice/notice";
import Vue from "vue";
export default {
  data() {
    return {
      groups: [],
      isNotice: false,
      groupsLength: "",
      params: {},
      classid: ""
    };
  },
  components: {
    notice
  },
  props: ["index"],
  created() {
    this.$nextTick(() => {
      this.getStudentsList();
    });
  },
  watch: {
    $route: "getStudentsList"
  },
  methods: {
    addGroup() {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 9,
        noticeTitle: "新建小组",
        identify: "addGroup",
        addGroups: this.groups,
        classid: this.classid
      };
    },
    edit(index) {
      this.isNotice = !this.isNotice;
      let allGroups = [];
      let editGroups = this.groups[index];
      this.groups.map(item => {
        if (item.title == editGroups.title) {
          return false;
        } else {
          allGroups.push(item);
        }
      });
      allGroups.map(item => {
        item.data.map(child => {
          child.checked = false;
        });
      });
      editGroups.data.map(sItem => {
        sItem.checked = true;
      });

      this.params = {
        type: 9,
        noticeTitle: "编辑小组",
        identify: "edit",
        editGroups: editGroups,
        allGroups: allGroups,
        classid: this.classid
      };
    },
    delTeam(index) {
      this.isNotice = !this.isNotice;
      this.params = {
        type: 10,
        noticeTitle: "删除确认",
        identify: "delete",
        groups: this.groups[index]
      };
    },

    isConfirm(val) {
      if(val) {
         let param = {
          classIds: this.classid,
          userRole: 1
        };
        this.getStuList(param);
      }
    },

    getStudentsList() {
      let groupsList = JSON.parse(window.sessionStorage.getItem("studentsListData"))[this.index];
      this.classid = groupsList.classId;
      this.groups = groupsList.students;
      this.groupsLength = groupsList.students.length;
      for (let i = 0; i < this.groups.length; i++) {
        const item = this.groups[i];
        if (item.title == "未分组") {
          this.groupsLength = this.groups.length - 1;
        }
      }
    },

    // 获取班级数据
    getStuList(param) {
      fetch.getMemberlist(param).then(res => {
        if (!res) {
          return false;
        }
        let newData = res.data[0];
        let students = this.getGroups(newData.data);
        let studentsListData = JSON.parse(
          window.sessionStorage.getItem("studentsListData")
        );
        window.sessionStorage.setItem("studentsListData", "");
        for (let i = 0, len = studentsListData.length; i < len; i++) {
          let item = studentsListData[i];
          let arr = [];
          if (newData.classId == item.classId) {
            item.students = students;
            item.data = newData.data
            students.newStu.map(sItem => {
              arr.push(sItem);
            });
            item.students = arr;
            break;
          }
        }
        window.sessionStorage.setItem("studentsListData",JSON.stringify(studentsListData));this.getStudentsList()
        // console.log(studentsListData, "new");
      });
    },

    // 获取班级的分组，对分组进行处理
    getGroups(students) {
      let group = {};
      let newStu = [];
      let groupTitles = [];
      let student_count = 0;
      students.sort((a, b) => {
        return a.userName.localeCompare(b.userName);
      });
      for (let index = 0, len = students.length; index < len; index++) {
        let item = students[index];
        if (item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        item.teamName = item.teamName || "未分组";
        const same_index = groupTitles.indexOf(item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: item.teamName,
            data: [item],
            count: 1,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          let group = newStu[same_index];
          group.data.push(item);
          group.count += 1;

          newStu[same_index] = group;
        }
        student_count++;
      }
      return { newStu, student_count };
    }
  }
};
</script>


// WEBPACK FOOTER //
// group.vue?48b60505